import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import { CreateTopic } from "../Models/Topic";
import { TopicType } from "../Enums/TopicType";
import { ToggleSetting } from "../../Layout";
import TopicWorkflowSelectorContainer from "./TopicWorkflows/TopicWorkflowSelector/TopicWorkflowSelectorContainer";

type Props = {
  toggle: boolean;
  onToggle: () => void;
  onCreate: (topic: CreateTopic, callback: () => void) => void;
};

type State = {
  topic: CreateTopic;
  topicTypeState: boolean;
};

export class CreateTopicModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      topic: {
        name: "",
        description: "",
        type: TopicType.Public
      },
      topicTypeState: true
    };
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const edit = { [event.target.name as any]: event.target.value };

    this.setState((prevState: State) => ({
      topic: { ...prevState.topic, ...edit }
    }));
  };

  onTopicTypeToggle = () => {
    this.setState(
      prevState => ({
        topicTypeState: !prevState.topicTypeState
      }),
      () =>
        this.setState(prevState => ({
          topic: {
            ...prevState.topic,
            type: prevState.topicTypeState ? TopicType.Public : TopicType.Private
          }
        }))
    );
  };

  onWorkflowChange = (newCode: string) => {
    const editedTopic = { ...this.state.topic, workflowCode: newCode };

    this.setState({
      topic: { ...editedTopic }
    });
  };

  onSaveClick = () => {
    this.props.onCreate(this.state.topic, this.onToggle);
  };

  onToggle = () => {
    this.setState(
      {
        topic: {
          name: "",
          description: "",
          type: TopicType.Public
        },
        topicTypeState: true
      },
      () => this.props.onToggle()
    );
  };

  render() {
    const isCreateActive = !!this.state.topic.workflowCode;

    return (
      <Modal size="lg" isOpen={this.props.toggle} toggle={this.onToggle}>
        <ModalHeader toggle={this.onToggle}>Create Topic</ModalHeader>
        <ModalBody>
          <Form
            onSubmit={e => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <FormGroup>
              <Label for="topic-name">Topic Name</Label>
              <Input
                type="text"
                id="topic-name"
                name="name"
                value={this.state.topic.name}
                onChange={this.onChange}
                autoComplete="off"
                required
              />
            </FormGroup>
            <FormGroup>
              <ToggleSetting
                settingName="Visible to public"
                settingDescription="This changes whether this topic is visible to all users within your company or only to select users"
                state={this.state.topicTypeState}
                onToggle={this.onTopicTypeToggle}
              />
            </FormGroup>
            <FormGroup>
              <Label for="topic-description">Topic Description</Label>
              <Input
                rows="7"
                type="textarea"
                id="topic-description"
                name="description"
                value={this.state.topic.description}
                onChange={this.onChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Workflow Template</Label>
              <TopicWorkflowSelectorContainer
                selectedWorkflowCode={this.state.topic.workflowCode}
                onSelectedWorkflowChange={this.onWorkflowChange}
              />
              <small>
                This template will be used to create a workflow for the new Topic, which can be
                adjusted later
              </small>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onSaveClick} disabled={!isCreateActive}>
            Save
          </Button>
          <Button onClick={this.onToggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}
